import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { isGlobalAdminUser } from '../../utils/accessControl';
import Loader from './loader/loader';

interface GlobalAdminRouteProps {
  children: React.ReactNode;
}

// Restricts a route to global admin users only; anyone else is redirected away.
const GlobalAdminRoute: React.FC<GlobalAdminRouteProps> = ({ children }) => {
  const { loading } = useAuth();

  if (loading) {
    return <Loader />;
  }

  if (!isGlobalAdminUser()) {
    return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
};

export default GlobalAdminRoute;
